module.exports = __webpack_public_path__ + "static/media/bd-nurse-med-station-2.d0f844eb.jpg";